import { Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import * as Yup from 'yup';
import { useUpdateCredentialsMutation } from '../../api/authApiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    password: Yup.string().required().min(6).label('Password'),
    current_password: Yup.string().required().label('Current Password'),
    password_confirmation: Yup.string().oneOf(
        [Yup.ref('password'), null],
        'Passwords must match'
    ),
});

export default function ChangePasswordScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const [updateCredentials, { isLoading }] = useUpdateCredentialsMutation();

    return (
        <Screen title="Change Password">
            <Grid item xs={12}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Form
                        validationSchema={validate}
                        onSubmit={async (vals, { resetForm }) => {
                            const { error, data } = await updateCredentials(
                                vals
                            );

                            errorSnackbar(error, enqueueSnackbar);

                            if (data) {
                                enqueueSnackbar('Success');
                                resetForm();
                            }
                        }}
                        initialValues={{
                            password: '',
                            current_password: '',
                            password_confirmation: '',
                        }}
                    >
                        <FormikInput
                            type="password"
                            placeholder="Current Password"
                            name="current_password"
                        />
                        <FormikInput
                            type="password"
                            placeholder="New Password"
                            name="password"
                        />
                        <FormikInput
                            type="password"
                            placeholder="Confirm New Password"
                            name="password_confirmation"
                        />
                        <FormikButton variant="contained" loading={isLoading}>
                            Change Password
                        </FormikButton>
                    </Form>
                </div>
            </Grid>
        </Screen>
    );
}
